<template>
  <div class="container free_ticket">
    <indexTitle english_title="Free Ticket" chinese_title="預約看展抽豪禮"></indexTitle>
    <div class="row" style="margin:30px 0;">
      <div class="ticket_top row col-lg-12" v-for="ticket in freeTickets.slice(0, 1)" :key="ticket.id">
        <div class="col-lg-6">
          <a :href="ticket.url" target="_blank"><img
              :src="ticket.cms_fb_image_url != undefined ? ticket.cms_fb_image_url : ticket.image_url" :alt="ticket.title">
            <div id="free_ticket_icon">免費索票<i class="fa fa-caret-right"></i></div>
          </a>
        </div>
        <div class="col-lg-6">
          <h3><a :href="ticket.url" target="_blank" v-html="ticket.title"></a></h3>
          <p><i class="fa fa-calendar" style="width: 15px;text-align:center;"></i><span
              v-html="' ' + ticket.start_date + '~' + ticket.end_date.slice(5, 10)"></span></p>
          <p><i class="fa fa-map-marker" style="width: 15px;text-align:center;"></i><span
              v-html="' ' + ticket.location"></span></p>
          <p class="info_describe">{{ ticket.description }}</p>
          <p><a :href="ticket.url" target="_blank">{{ ticket.button_display }} ⇀</a></p>
        </div>
      </div>
      <div class="ticket_down row col-lg-12">
        <div class="ticket_info row col-lg-6 col-12" v-for="ticket in freeTickets.slice(1, 5)" :key="ticket.id">
          <div class="ticket_info_image col-xl-7 col-6">
            <a :href="ticket.url" target="_blank"><img
                :src="ticket.cms_fb_image_url != undefined ? ticket.cms_fb_image_url : ticket.image_url"
                :alt="ticket.title"></a>
          </div>
          <div class="ticket_info_content col-xl-5 col-6">
            <h3><a :href="ticket.url" target="_blank" v-html="ticket.title"></a></h3>
            <p><i class="fa fa-calendar" style="width: 15px;text-align:center;"></i><span
                v-html="' ' + ticket.start_date + '~' + ticket.end_date.slice(5, 10)"></span></p>
            <p><i class="fa fa-map-marker" style="width: 15px;text-align:center;"></i><span
                v-html="' ' + ticket.location"></span></p>
            <p><a :href="ticket.url" target="_blank">{{ ticket.button_display }} ⇀</a></p>
          </div>
        </div>
      </div>
    </div>
    <moreButton button_text="更多免費" button_href="freeticket"></moreButton>
  </div>
</template>

<script>
import IndexTitle from '@/components/index/IndexTitle'
import MoreButton from '@/components/index/MoreButton'

export default {
  name: 'freeTicket',
  props: {},
  data() {
    return {
      // 測試用資料
      freeTickets: [
        // {
        //   title: '台中美食伴手禮展',
        //   image_url: require('../../assets/ticket/ticket_01.jpg'),
        //   start_date: '2018/12/14',
        //   end_date: '2018/12/17',
        //   location: '大台中國際會展中心',
        //   url: 'https://tctravel-shop.top-link.com.tw/home',
        //   button_display: '免費索票 立即預約',
        //   description: '中台灣年度美食饗宴-2018台中美食暨伴手禮展將在12/14-17大台中國際會展中心盛大展開，台中美食伴手禮展匯集世界各大美食及伴手禮大廠，異國料理、道地小吃、甜點王國…等，並提前推出特色年節禮盒，提供企業、團購展場獨家促銷優惠。'
        // },
        // {
        //   title: '2018 台中烏日國際旅展(冬季展)',
        //   image_url: require('../../assets/ticket/ticket_02.jpg'),
        //   start_date: '2018/12/14',
        //   end_date: '2018/12/17',
        //   location: '大台中國際會展中心',
        //   url: 'https://tctravel-shop.top-link.com.tw/home',
        //   button_display: '免費索票 立即預約',
        //   description: '中台灣年度美食饗宴-2018台中美食暨伴手禮展將在12/14-17大台中國際會展中心盛大展開，台中美食伴手禮展匯集世界各大美食及伴手禮大廠，異國料理、道地小吃、甜點王國…等，並提前推出特色年節禮盒，提供企業、團購展場獨家促銷優惠。'
        // },
        // {
        //   title: '台中美食伴手禮展',
        //   image_url: require('../../assets/ticket/ticket_03.jpg'),
        //   start_date: '2018/12/14',
        //   end_date: '2018/12/17',
        //   location: '大台中國際會展中心',
        //   url: 'https://tctravel-shop.top-link.com.tw/home',
        //   button_display: '免費索票 立即預約',
        //   description: '中台灣年度美食饗宴-2018台中美食暨伴手禮展將在12/14-17大台中國際會展中心盛大展開，台中美食伴手禮展匯集世界各大美食及伴手禮大廠，異國料理、道地小吃、甜點王國…等，並提前推出特色年節禮盒，提供企業、團購展場獨家促銷優惠。'
        // },
        // {
        //   title: '台中美食伴手禮展',
        //   image_url: require('../../assets/ticket/ticket_04.jpg'),
        //   start_date: '2018/12/14',
        //   end_date: '2018/12/17',
        //   location: '大台中國際會展中心',
        //   url: 'https://tctravel-shop.top-link.com.tw/home',
        //   button_display: '免費索票 立即預約',
        //   description: '中台灣年度美食饗宴-2018台中美食暨伴手禮展將在12/14-17大台中國際會展中心盛大展開，台中美食伴手禮展匯集世界各大美食及伴手禮大廠，異國料理、道地小吃、甜點王國…等，並提前推出特色年節禮盒，提供企業、團購展場獨家促銷優惠。'
        // },
        // {
        //   title: '台中美食伴手禮展',
        //   image_url: require('../../assets/ticket/ticket_05.jpg'),
        //   start_date: '2018/12/14',
        //   end_date: '2018/12/17',
        //   location: '大台中國際會展中心',
        //   url: 'https://tctravel-shop.top-link.com.tw/home',
        //   button_display: '免費索票 立即預約',
        //   description: '中台灣年度美食饗宴-2018台中美食暨伴手禮展將在12/14-17大台中國際會展中心盛大展開，台中美食伴手禮展匯集世界各大美食及伴手禮大廠，異國料理、道地小吃、甜點王國…等，並提前推出特色年節禮盒，提供企業、團購展場獨家促銷優惠。'
        // }
      ]
    }
  },
  components: {
    'indexTitle': IndexTitle,
    'moreButton': MoreButton
  },
  computed: {},
  created() {
    var app = this
    var free_ticket_api = process.env.VUE_APP_API + 'tlweb/free'
    this.axios
      .get(free_ticket_api)
      .then((res) => {
        app.freeTickets = res.data.data.data
      })
      .catch((err) => {
        console.log('錯誤:' + err)
      })
  }
}
</script>

<style lang="sass">
$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

$free_ticket_icon_bg: #e8473f

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

#free_ticket_icon 
  display: none // 協理說很醜要拿掉
  position: absolute
  bottom: 0
  right: 0
  background: $free_ticket_icon_bg
  color: white
  font-size: 27px
  letter-spacing: 12px
  text-align: center
  padding: 2.3% 0
  padding-left: 30px
  &:before 
    content: ' '
    display: block
    position: absolute
    background: $free_ticket_icon_bg
    height: 100%
    width: 63px
    border-radius: 50%
    top: 0
    left: 0
    transform: translateX(-50%)
  @include pc-width 
    right: 15px
  @include pad-width
    right: 0
    font-size: 23px
  @include mobile-width 
    font-size: 19px
    &:before 
      width: 40px

.free_ticket 
  img 
    width: 100%
    max-width: 100%
    display: block
    margin: auto
  a 
    color: #00a0e9
    text-decoration: none
    font-weight: bold
    display: block
    position: relative
  .ticket_top
    h3 
      font-size: 19px
      margin: 0 0 10px 0
    img 
      box-shadow: 15px -15px #8fc43d
    p 
      font-size: 15px
    .info_describe 
      color: grey
      line-height: 1.5
      font-size: 14px
    @include pc-width
      h3 
        margin: 20px 0 10px 0
      
  .ticket_down
    .ticket_info
      margin: 30px 0 0 0
      h3
        font-size: 17px
        margin: 0 0 10px 0
        a 
          color: black
      .ticket_info_image 
        padding: 0
        img
          box-shadow: 2px 3px 7px #bfbfbf
      .ticket_info_content 
        padding: 0 0 0 10px
        p
          font-size: 15px
        p:nth-child(2)
          margin: 0
          margin-top: 15px
        // p:nth-child(3) 
        //   margin: 0
        //   margin-top: 8px
  @include mobile-width 
    .row 
      margin: 0
      padding: 0
    .ticket_down
      .ticket_info
        padding: 0
        margin: 10px 0 0 0
        h3
          font-size: 15px
        .ticket_info_content 
          p 
            font-size: 13px

</style>
